jQuery(document).ready(function($) {
    $('.tablinks').on('click', function() {
        var dataId = $(this).data('id');

        // Filter posts
        if (dataId === 'all') {
            $('.post').show(); // Show all posts
        } else {
            $('.post').hide(); // Hide all posts
            $('.post[data-id*="' + dataId + '"]').show(); // Show posts with matching data-id
        }

        // Set active class on button
        $('.tablinks').removeClass('active bg-blue text-white'); // Remove active class from all buttons
        $(this).addClass('active bg-blue text-white'); // Add active class to the clicked button
    });

    // Show all posts on "Show All" button click
    $('#show-all-button').on('click', function() {
        $('.post').show(); // Show all posts

        // Set active class on button
        $('.tablinks').removeClass('active bg-blue text-white'); // Remove active class from all buttons
        $(this).addClass('active bg-blue text-white'); // Add active class to the clicked button
    });
});
//# sourceMappingURL=article-filter.js.map
